import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BackgroundColor from './BackgroundColor';
import ClientProvider from './client';
export default createDemo(import.meta.url, BackgroundColor, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/palette/demos/background-color/BackgroundColor.tsx",
    "fileName": "BackgroundColor.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\n\nexport default function BackgroundColor() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Grid container spacing={1}>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', p: 2 }}>\n          primary.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box\n          sx={{ bgcolor: 'secondary.main', color: 'secondary.contrastText', p: 2 }}\n        >\n          secondary.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'error.main', color: 'error.contrastText', p: 2 }}>\n          error.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'warning.main', color: 'warning.contrastText', p: 2 }}>\n          warning.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'info.main', color: 'info.contrastText', p: 2 }}>\n          info.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'success.main', color: 'success.contrastText', p: 2 }}>\n          success.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'text.primary', color: 'background.paper', p: 2 }}>\n          text.primary\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'text.secondary', color: 'background.paper', p: 2 }}>\n          text.secondary\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'text.disabled', color: 'background.paper', p: 2 }}>\n          text.disabled\n        </Box>\n      </Grid>\n    </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 101,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\n\nexport default function BackgroundColor() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Grid container spacing={1}>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', p: 2 }}>\n          primary.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box\n          sx={{ bgcolor: 'secondary.main', color: 'secondary.contrastText', p: 2 }}\n        >\n          secondary.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'error.main', color: 'error.contrastText', p: 2 }}>\n          error.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'warning.main', color: 'warning.contrastText', p: 2 }}>\n          warning.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'info.main', color: 'info.contrastText', p: 2 }}>\n          info.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'success.main', color: 'success.contrastText', p: 2 }}>\n          success.main\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'text.primary', color: 'background.paper', p: 2 }}>\n          text.primary\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'text.secondary', color: 'background.paper', p: 2 }}>\n          text.secondary\n        </Box>\n      </Grid>\n      <Grid\n        size={{\n          xs: 12,\n          sm: 4,\n        }}\n      >\n        <Box sx={{ bgcolor: 'text.disabled', color: 'background.paper', p: 2 }}>\n          text.disabled\n        </Box>\n      </Grid>\n    </Grid>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 101,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Grid"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
